import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import axios from 'axios';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBoxes,
    faScrewdriver,
    faSignOutAlt,
    faTachometerAlt,
    faPuzzlePiece,
    faBoxOpen,
    faReceipt,
    faTruckLoading,
    faMoneyCheck,
    faMoneyBill,
    faBuilding,
    faPeopleCarry,
    faClipboardList,
    faFileAlt,
    faFileExcel,
    faUser,
    faUsers,
    faChartLine,
    faStore,
    faShoppingCart,
    faList,
    faEye,
    faTruck
} from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../Services/AuthenticationService';

const styles = theme => ({
    palette: {
        primary: { main: '#FFF' },
        secondary: { main: '#03a9f4' },
        contrastText: '#fff',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 15px',
        ...theme.mixins.toolbar,
    },
    drawerPaper: {
        width: 350,
        height: '100%',
        padding: 20,
        outline: 'none',
        marginTop: 0
    },
});

let globalProps;

class NavigationDrawer extends React.Component {
    constructor(props){
        super(props);
        const authService = AuthenticationService.getInstance();
        
        this.state = {
            jwtToken: authService.getToken(),
            userId: authService.getUserId(),
            permissions: localStorage.getItem('permissions'),
        };
        
        const token = authService.getToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    }

    logout = () => {
        AuthenticationService.getInstance().logout();
        this.props.history.push('/login');
    };

    myDashboard = () => {
        this.props.history.push('/dashboard');
    };

    adminAssemblies = () => {
        this.props.history.push('/admin/assemblies');
    };

    adminProductListings = () => {
        this.props.history.push('/admin/product-listings');
    };

    adminCustomerCarts = () => {
        this.props.history.push('/admin/customer-carts');
    };

    adminParts = () => {
        this.props.history.push('/admin/parts');
    };

    adminVendors = () => {
        this.props.history.push('/admin/vendors');
    };

    adminParentChild = () => {
        this.props.history.push('/admin/parentchild');
    };

    adminPackaging = () => {
        this.props.history.push('/admin/packaging');
    };

    adminBillOfMaterials = () => {
        this.props.history.push('/admin/bom');
    };

    adminInventory = () => {
        this.props.history.push('/admin/inventory');
    };

    adminPurchases = () => {
        this.props.history.push('/admin/purchases');
    };

    adminInvoices = () => {
        this.props.history.push('/admin/invoices');
    };

    adminPackingSlips = () => {
        this.props.history.push('/admin/packing-slips');
    };

    adminSales = () => {
        this.props.history.push('/admin/sales');
    };

    adminOrders = () => {
        this.props.history.push('/admin/orders');
    };

    adminShippingMethods = () => {
        this.props.history.push('/admin/shipping-methods');
    };

    adminDealerSheet = () => {
        this.props.history.push('/admin/dealer-sheet');
    };

    adminAnalytics = () => {
        this.props.history.push('/admin/analytics');
    };

    adminLists = () => {
        this.props.history.push('/admin/lists');
    };

    adminUserManagement = () => {
        this.props.history.push('/admin/users');
    };

    adminHomepageCategories = () => {
        this.props.history.push('/admin/customer-site-controls');
    };

    myProfile = () => {
        this.props.history.push('/admin/profile');
    };

    adminFamilies = () => {
        this.props.history.push('/admin/families');
    };

    adminCategories = () => {
        this.props.history.push('/admin/categories/parts');
    };

    adminAssemblyCategories = () => {
        this.props.history.push('/admin/categories/assemblies');
    };

    workshopTools = () => {
        this.props.history.push('/search');
    };

    systemAdminPanel = () => {
        this.props.history.push('/admin/system');
    };

    isActive = (path) => {
        return this.props.location.pathname === path || this.props.location.pathname.startsWith(path + '/');
    };

    render(){
        const user = AuthenticationService.getInstance().getUser();
        const permissions = user ? user.userPermissions : [];

        let adminAssemblies;
        let adminProductListings;
        let adminCustomerCarts;
        if (user.isAdministrator)
            adminAssemblies =
                    <ListItem button onClick={this.adminAssemblies} className={`navItem ${this.isActive('/admin/assemblies') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faBoxes} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Assemblies</Typography>} />
                    </ListItem>;
        if (user.isAdministrator)
            adminProductListings =
                    <ListItem button onClick={this.adminProductListings} className={`navItem ${this.isActive('/admin/product-listings') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faStore} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Product Listings</Typography>} />
                    </ListItem>;
        if (user.isAdministrator)
            adminCustomerCarts =
                    <ListItem button onClick={this.adminCustomerCarts} className={`navItem ${this.isActive('/admin/customer-carts') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faShoppingCart} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Customer Carts</Typography>} />
                    </ListItem>;
        let adminParts;
        if (user.isAdministrator)
            adminParts =
                    <ListItem button onClick={this.adminParts} className={`navItem ${this.isActive('/admin/parts') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faScrewdriver} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Parts</Typography>} />
                    </ListItem>;
        let adminVendors;
        if (user.isAdministrator)
            adminVendors =
                    <ListItem button onClick={this.adminVendors} className={`navItem ${this.isActive('/admin/vendors') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faStore} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Vendors</Typography>} />
                    </ListItem>;
        let adminFamilies;
        if (user.isAdministrator)
            adminFamilies =
                    <ListItem button onClick={this.adminFamilies} className={`navItem ${this.isActive('/admin/families') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faPeopleCarry} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Families</Typography>} />
                    </ListItem>;
        let adminParentChild;
        if (user.isAdministrator)
            adminParentChild =
                    <ListItem button onClick={this.adminParentChild} className={`navItem ${this.isActive('/admin/parentchild') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faPuzzlePiece} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Parent Child</Typography>} />
                    </ListItem>;
        let adminPackaging;
        if (user.isAdministrator && permissions.includes('Workshop'))
            adminPackaging =
                    <ListItem button onClick={this.adminPackaging} className={`navItem ${this.isActive('/admin/packaging') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faBoxOpen} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Packaging</Typography>} />
                    </ListItem>;
        let adminBOM;
        if (user.isAdministrator)
            adminBOM =
                    <ListItem button onClick={this.adminBillOfMaterials} className={`navItem ${this.isActive('/admin/bom') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faReceipt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Bill Of Materials</Typography>} />
                    </ListItem>;
        let adminInventory;
        if (user.isAdministrator && permissions.includes('Purchase'))
            adminInventory =
                    <ListItem button onClick={this.adminInventory} className={`navItem ${this.isActive('/admin/inventory') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faTruckLoading} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Inventory</Typography>} />
                    </ListItem>;
        let adminPurchases;
        if (user.isAdministrator && permissions.includes('Purchase'))
            adminPurchases =
                    <ListItem button onClick={this.adminPurchases} className={`navItem ${this.isActive('/admin/purchases') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faMoneyCheck} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Purchases</Typography>} />
                    </ListItem>;
        let adminInvoices;
        if (user.isAdministrator && permissions.includes('Purchase'))
            adminInvoices =
                    <ListItem button onClick={this.adminInvoices} className={`navItem ${this.isActive('/admin/invoices') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faFileAlt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Invoices</Typography>} />
                    </ListItem>;
        let adminPackingSlips;
        if (user.isAdministrator && permissions.includes('Purchase'))
            adminPackingSlips =
                    <ListItem button onClick={this.adminPackingSlips} className={`navItem ${this.isActive('/admin/packing-slips') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faClipboardList} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">Packing Slips</Typography>} />
                    </ListItem>;
        let adminSales;
        if (user.isAdministrator && permissions.includes('Purchase'))
            adminSales =
                <ListItem button onClick={this.adminSales} className={`navItem ${this.isActive('/admin/sales') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faMoneyBill} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Sales</Typography>} />
                </ListItem>;
        let adminOrders;
        if (user.isAdministrator)
            adminOrders =
                <ListItem button onClick={this.adminOrders} className={`navItem ${this.isActive('/admin/orders') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faReceipt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Orders</Typography>} />
                </ListItem>;
        let adminShippingMethods;
        if (user.isAdministrator)
            adminShippingMethods =
                <ListItem button onClick={this.adminShippingMethods} className={`navItem ${this.isActive('/admin/shipping-methods') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faTruck} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Shipping Methods</Typography>} />
                </ListItem>;
        let adminDealerSheet;
        if (user.isAdministrator && permissions.includes('EditAssembliesAndParts'))
            adminDealerSheet =
                <ListItem button onClick={this.adminDealerSheet} className={`navItem ${this.isActive('/admin/dealer-sheet') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faFileExcel} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Dealer Sheet</Typography>} />
                </ListItem>;
        let adminAnalytics;
        if (user.isAdministrator)
            adminAnalytics =
                <ListItem button onClick={this.adminAnalytics} className={`navItem ${this.isActive('/admin/analytics') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faChartLine} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Analytics</Typography>} />
                </ListItem>;
        let adminLists;
        if (user.isAdministrator)
            adminLists =
                <ListItem button onClick={this.adminLists} className={`navItem ${this.isActive('/admin/lists') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faList} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Lists</Typography>} />
                </ListItem>;
        let adminUserManagement;
        if (user.isAdministrator && permissions.includes('EditPermissions'))
            adminUserManagement =
                <ListItem button onClick={this.adminUserManagement} className={`navItem ${this.isActive('/admin/users') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faUsers} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">User Management</Typography>} />
                </ListItem>;
        let adminHomepageCategories;
        if (user.isAdministrator)
            adminHomepageCategories =
                <ListItem button onClick={this.adminHomepageCategories} className={`navItem ${(this.isActive('/admin/customer-site-controls') || this.isActive('/admin/homepage-categories')) ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faEye} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Customer Site</Typography>} />
                </ListItem>;
        let myDashboard;
        /*if (!user.isAdministrator)
            myDashboard =
                <Tooltip title="My Dashboard" aria-label="My Dashboard" placement="right" TransitionComponent={Zoom}>
                    <ListItem button onClick={this.myDashboard} className="navItem">
                        <span className="navIcon"><FontAwesomeIcon icon={faTachometerAlt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                        <ListItemText primary={<Typography className="navText">My Dashboard</Typography>} />
                    </ListItem>
                </Tooltip>;*/
        const myProfile =
                <ListItem button onClick={this.myProfile} className={`navItem ${this.isActive('/profile') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faUser} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">My Profile</Typography>} />
                </ListItem>;

        const logout =
                <ListItem button onClick={this.logout} className="navItem">
                    <span className="navIcon"><FontAwesomeIcon icon={faSignOutAlt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Logout</Typography>} />
                </ListItem>;
        let workshopTools;
        if (user.isAdministrator && permissions.includes('Workshop'))
            workshopTools =
                <ListItem button onClick={this.workshopTools} className={`navItem ${this.isActive('/search') ? 'active' : ''}`}>
                    <span className="navIcon"><FontAwesomeIcon icon={faBuilding} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    <ListItemText primary={<Typography className="navText">Workshop Tools</Typography>} />
                </ListItem>;

        return (
            <List style={{color: '#004612'}}>
                { workshopTools }
                { adminParts }
                { adminAssemblies }
                {/* { adminProductListings } */}
                {/* { adminCustomerCarts } */}
                { adminFamilies }
                { adminPackaging }
                { adminBOM }
                { adminInventory }
                { adminPurchases }
                { adminInvoices }
                { adminPackingSlips }
                { adminSales }
                { adminOrders }
                {/* { adminShippingMethods } */}
                { adminParentChild }
                { adminAnalytics }
                { adminLists }
                { adminUserManagement }
                { adminDealerSheet }
                {/* { adminHomepageCategories } */}
                { myProfile }
                { logout }
            </List>
        )
    }
}

NavigationDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
};

NavigationDrawer = withRouter(NavigationDrawer);
export default withStyles(styles)(NavigationDrawer);
